<template>
<div>
  <Navbar></Navbar>
  <main>
    <div class="container mx-auto sm:px-2 lg:px-8">
      <!-- Replace with your content -->
      <div class="px-4 py-3 sm:px-0 font-display">
        <router-view />
      </div>
      <!-- /End replace -->
    </div>
  </main>
  <footer>
    <div class="text-center mt-5 mb-5">
      Feito com <font-awesome-icon class="text-red-600" icon="heart" /> por <strong>Estico</strong>
    </div>
  </footer>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>
